var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3356 15.4685C13.0769 15.7919 12.6049 15.8444 12.2815 15.5856L4.78145 9.58562C4.60354 9.4433 4.49997 9.22781 4.49997 8.99997C4.49997 8.77214 4.60354 8.55665 4.78145 8.41432L12.2815 2.41432C12.6049 2.15556 13.0769 2.208 13.3356 2.53145C13.5944 2.8549 13.5419 3.32687 13.2185 3.58562L6.45056 8.99997L13.2185 14.4143C13.5419 14.6731 13.5944 15.145 13.3356 15.4685Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLess);
export default __webpack_public_path__ + "static/media/less.5801e69a5c1d8d155225acd61addfc95.svg";
export { ForwardRef as ReactComponent };